import Hero from "../components/Hero";
import FeaturedCars from "../components/FeaturedCars";
import Testimonials from "../components/Testimonials";

function Home() {

  return (
    <>
      <Hero />
      <FeaturedCars />
      <Testimonials />
    </>
  );
}

export default Home;